import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
import { UnindexedRecordDocImageComponent } from '../../components/unindexed-record-doc-image/unindexed-record-doc-image.component';

@Component({
  selector: 'app-unindexed-record-doc-disp-pg',
  templateUrl: './unindexed-record-doc-disp-pg.component.html',
  styleUrls: ['./unindexed-record-doc-disp-pg.component.css']
})
export class UnindexedRecordDocDispPgComponent implements OnInit {

  public book: string;
  public page: string;
  public indexId: string;
  //public indexbook: string;
  //public indexgroup: string;
  //public indexpage: string;
  //public dategroup: number;
  collapsesideinfo: boolean = false;
  //public record: RecDocVM;
  error: any;
  public isImgVwVisible: boolean = true;
  public isLoadingDetail: boolean = true;
  @ViewChild(UnindexedRecordDocImageComponent, { static: false }) unindexedRecordDocImageComponent;
  screenWidth: any;


  constructor(private route: ActivatedRoute, private router: Router, private nav: NavMenuService) {

  }

  ngOnInit() {
    this.book = this.route.snapshot.paramMap.get('Book');
    this.page = this.route.snapshot.paramMap.get('Page');
    this.indexId = this.route.snapshot.paramMap.get('indexId');

    //this.indexbook = this.route.snapshot.paramMap.get('indexbook');
    //this.indexgroup = this.route.snapshot.paramMap.get('indexgroup');
    //this.indexpage = this.route.snapshot.paramMap.get('indexpage');
    //this.dategroup = Number(this.route.snapshot.paramMap.get('dategroup'));
    console.log('book: ' + this.book + ' ' + this.page + ' ' + this.indexId );
    this.nav.hide();
    this.isLoadingDetail = true;
  }

  back(url) {

    this.router.navigate([url]);
    this.nav.show();
    //window.opener = 'Self';
    //window.open('', '_parent', '');
    //window.close();

  }


  toggleSideInfo() {
    this.collapsesideinfo = !this.collapsesideinfo;

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  getIsImgVwVisible(e) {
    this.isImgVwVisible = e;
  }
}
